import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Mainroutes from "./main.routes";
import { NumberProvider } from "./context/StandardContext";
import 'react-toastify/dist/ReactToastify.css';
import { DateProvider } from "./context/SelectDate";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <NumberProvider>
    <DateProvider>
    <BrowserRouter>
      <ToastContainer position="bottom-right" autoClose={3000} stacked />
      <Mainroutes />
    </BrowserRouter>
    </DateProvider>
  </NumberProvider>
);
